module.exports = __webpack_public_path__ + "static/media/LightningBolt.9e7b3978.glb";